<template>

    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addManufacturer></addManufacturer>
    </v-dialog>

</template>

<script>
    import {ManufacturersSettings} from '../../../store/namespace-helper'

    import addManufacturer from '../../Shared/AddManufacturer.vue'

    export default {
      name: 'add-new-manufacturer-dialog',
      components: {
        addManufacturer
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[ManufacturersSettings.getters.getOpenNewManufacturerDialogState]
        }
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Settings/Manufacturers/AddManufacturerDialog.vue